import { getAttributeGroups } from "../../../../api/attributes";
import { getOptionGroups } from "../../../../api/options";

export const attributeValues = (row) =>
  Array.isArray(row.values)
    ? row.values.map((value) => value.name).join(" · ") || "—"
    : "No disponible";
export const getAttributeList = async () => {
  const [attributes, variants] = await Promise.all([
    getAttributeGroups(),
    getOptionGroups(),
  ]);
  if (
    attributes?.error !== false ||
    variants?.error !== false ||
    !Array.isArray(attributes.data) ||
    !Array.isArray(variants.data)
  )
    return { error: true };
  return {
    error: false,
    data: [
      ...attributes.data.map((group) => ({
        ...group,
        listId: `attribute:${group.itemGroupId}`,
        type: "attribute",
        values: Array.isArray(group.items) ? [...group.items].sort((a,b) => (Number(a.ItemItemGroups?.order) || 0) - (Number(b.ItemItemGroups?.order) || 0)) : group.items,
      })),
      ...variants.data.map((group) => ({
        ...group,
        listId: `variant:${group.optionGroupId}`,
        type: "variant",
        values: group.options,
      })),
    ],
  };
};
